export const messages = {
  state: {},
  reducers: {
    remove(state, id) {
      const newState = Object.assign({}, state);
      delete newState[id.toString()];
      return newState;
    },
    update(state, { id, $lastModified }) {
      return Object.assign({}, state, { [id]: $lastModified });
    },
  },
  effects: {
    removeMessage({ id }, rootState) {
      if (rootState.messages[id.toString()]) {
        this.remove(id);
      }
    },
    updateMessage(message, rootState) {
      if (message.conversationId === rootState.conversation.id) {
        this.update(message);
      }
    },
  },
};
